/* eslint-disable react/forbid-component-props */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { scroller } from 'react-scroll';
import { CYF_DEAL_TYPE } from '../../../../brands/default/config';
import { SCROLL_CONSTANTS } from '../../../../brands/default/constants';
import { GIFTING_BUTTON } from '../../../../brands/default/content/components/deal';
import {
  GIFTING_BTN_OTHER_VARIANT,
  SHOW_GIFTING_BUTTON,
} from '../../../../brands/default/features';
import { GIFT_ICON_IMG } from '../../../../config/constants/images';
import {
  getIsChooseYourOptionsDeal,
  getIsChooseYourProductDeal,
  getIsLeadGen,
  isBookingCalendarChooseDateDeal,
  isBookingCalendarOnRedemptionDeal,
} from '../../../../helpers/deals';
import { getScreenBreakpoint } from '../../../../helpers/screen';
import ThemeContext from '../../../../providers/ThemeProvider';
import PrimaryButton from '../../../_generic/button/PrimaryButton';
import GiftingModal from './GiftingModal';

const GiftingButton = ({
  deal = {},
  columnSelection,
  isMobile = false,
  mainDealGiftButton,
  position,
  isProductPage = false,
  setShowEmptyMessage,
  mainDealGiftingChooseYourOptionsButton,
  isSoldOut,
  rowSelection,
}) => {
  const theme = useContext(ThemeContext);
  const [showModal, setShowModal] = useState(false);
  const isCYF = deal.dealType === CYF_DEAL_TYPE;
  let noButton = false;

  if (!deal || !deal.giftable) return null;

  // will need these functions and also selectedOptions, onSetShowMultiError,
  // targetScroll and isEvergreen for ITB-76
  const isChooseYourProduct = getIsChooseYourProductDeal(deal);
  const isChooseYourOptions = getIsChooseYourOptionsDeal(deal);
  const isBookingCalendarChooseDate = isBookingCalendarChooseDateDeal(deal);
  const isBookingCalendarOnRedemption = isBookingCalendarOnRedemptionDeal(deal);
  const isLeadGen = getIsLeadGen(deal);
  if (isLeadGen) return null;

  if (
    isBookingCalendarChooseDate ||
    isBookingCalendarOnRedemption ||
    (isChooseYourOptions && !isProductPage) ||
    isChooseYourProduct
  ) {
    noButton = true;
  }

  const scrollToBuySection = () => {
    setShowModal(false);
    const breakpoint = getScreenBreakpoint();

    scroller.scrollTo(SCROLL_CONSTANTS.CHOOSE_YOUR_OPTIONS_COMPONENT, {
      delay: 100,
      duration: 1_000,
      offset: breakpoint === 'sm' ? -300 : 0,
      smooth: true,
    });
  };
  if (!SHOW_GIFTING_BUTTON) {
    return null;
  }

  return (
    <div className="gifting-wrapper">
      <PrimaryButton
        className={classNames('gifting-btn', {
          'full-width gifting-btn--desktop': !isMobile,
          'gifting-btn--mobile': isMobile,
          'size-larger': isCYF && !isMobile,
        })}
        disabled={isSoldOut}
        onClick={() => setShowModal(true)}
      >
        <img
          alt={GIFTING_BUTTON.gifting}
          className={
            GIFTING_BTN_OTHER_VARIANT
              ? 'gifting-btn__img_ls'
              : 'gifting-btn__img'
          }
          src={GIFT_ICON_IMG}
        />
        <div className="gifting-btn__text">{GIFTING_BUTTON.gifting}</div>
      </PrimaryButton>

      {showModal && (
        <GiftingModal
          columnSelection={columnSelection}
          deal={deal}
          isProductPage={isProductPage}
          mainDealGiftButton={mainDealGiftButton}
          mainDealGiftingChooseYourOptionsButton={
            mainDealGiftingChooseYourOptionsButton
          }
          noButton={noButton}
          onClose={scrollToBuySection}
          position={position}
          rowSelection={rowSelection}
          setShowEmptyMessage={setShowEmptyMessage}
          setShowModal={setShowModal}
          showModal={showModal}
        />
      )}
      <style jsx>{`
        :global(.primary-button.gifting-btn) {
          background-color: #ffffff;
          color: ${theme.colors.primary};
          box-shadow: 1px 0px 8px #888888;
        }
        .gifting-wrapper {
          padding: 10px 0 20px;
        }
        .gifting-wrapper :global(.primary-button.gifting-btn--mobile) {
          width: auto;
        }
        .gifting-btn__img {
          margin-top: -7px;
          height: 25px;
          width: 25px;
        }
        // .gifting-btn__img_ls {
        //   margin-top: -2px;
        //   height: 16px;
        //   width: 16px;
        //   margin-right: 1%;
        // }
        .gifting-wrapper .gifting-btn__text {
          font-size: 14px;
        }
        .gifting-btn__text_ls {
          margin-top: 1%;
        }
        @media only screen and (min-width: ${theme.breakpoints.smUp}) {
          .gifting-wrapper {
            padding: 10px 0;
            text-align: center;
          }
          .gifting-wrapper .gifting-btn__text {
            font-size: 15px;
          }
        }
      `}</style>
    </div>
  );
};

GiftingButton.propTypes = {
  columnSelection: PropTypes.number,
  deal: PropTypes.object,
  isMobile: PropTypes.bool,
  isProductPage: PropTypes.bool,
  isSoldOut: PropTypes.bool,
  mainDealGiftButton: PropTypes.object,
  mainDealGiftingChooseYourOptionsButton: PropTypes.any,
  position: PropTypes.number,
  rowSelection: PropTypes.number,
  setShowEmptyMessage: PropTypes.func,
};

export default GiftingButton;
